import Immutable from 'seamless-immutable';

import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  hotsiteAttendanceRequest: ['query'],
  hotsiteAttendanceSuccess: ['data'],
  hotsiteAttendanceFailed: ['error'],
});

const INITIAL_STATE = Immutable({
  option: null,
  error: {},
  seo: {},
  menu: {},
  content: {},
});

const hotsiteRequest = (state = INITIAL_STATE, { query }) => state.set('option', query || null);

const hotsiteSuccess = (state = INITIAL_STATE, { data }) => state.merge(data);

const hotsiteFailed = (state = INITIAL_STATE, { error }) => state.set('error', error);

export default createReducer(INITIAL_STATE, {
  [Types.HOTSITE_ATTENDANCE_REQUEST]: hotsiteRequest,
  [Types.HOTSITE_ATTENDANCE_SUCCESS]: hotsiteSuccess,
  [Types.HOTSITE_ATTENDANCE_FAILED]: hotsiteFailed,
});
